import { Box, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useConstants } from "../hooks/UseConstants";
import { useMainLayout } from "../hooks/UseMainLayout";

function PageContent({ wait, loading, children }) {
    const theme = useTheme();
    const { language } = useConstants();
    const { areaClassName, areaSx } = useMainLayout();
    const isBusy = wait || loading;

    if (isBusy) {
        return (
            <Box
                className={`${areaClassName} h-screen relative flex justify-center items-center`}
                sx={areaSx}
            >
                <CircularProgress size={70} />
            </Box>
        );
    }

    return (
        <Box sx={{ backgroundColor: theme.palette.background.default, minHeight: '100vh' }}>
            <Box className={`${areaClassName} mt-10 pb-8`} sx={areaSx} dir={language === 'en' ? 'ltr' : 'rtl'}>
                {children}
            </Box>
        </Box>
    );
}

export default PageContent;
